import barba from '@barba/core';

$(function() {

    if ($('body').hasClass('page-template-template-school')) {
        window.initMapbox();
    }

});

barba.hooks.after(() => {
    if ($('body').hasClass('page-template-template-school')) {
        window.initMapbox();
    }
});
